import Badge from "@/components/ui/badge";
import Typography from "@/components/ui/typography";

interface ChatHeaderProps {
  userName?: string;
  hasMessages?: boolean;
  threadTitle?: string | null;
}

export const ChatHeader = ({
  userName = "there",
  hasMessages = false,
  threadTitle,
}: ChatHeaderProps) => {
  // If there are messages, show compact header
  if (hasMessages) {
    return (
      <div className="flex items-center gap-2">
        <Typography size="h1" className="text-sds-text-black font-semibold">
          Chatting now with Stacey
        </Typography>
        <Badge color="purple" variant="full">
          Beta
        </Badge>
      </div>
    );
  }

  // New chat - show full greeting
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col">
        <Typography size="h1" className="text-sds-text-black font-normal">
          Hey there, {userName}!
        </Typography>
        <div className="flex items-center gap-2">
          <Typography size="h1" className="text-sds-text-black font-semibold">
            I'm Stacey
          </Typography>
          <Badge color="purple" variant="full">
            Beta
          </Badge>
        </div>
      </div>
      <Typography size="sh1" className="text-sds-neutral-80 font-normal">
        Your solopreneur co-pilot for building and scaling your business.
      </Typography>
    </div>
  );
};
